<template>
  <modal v-ref:modal :is-shown.sync="isShown" size="lg">
    <div slot="content">
      <div class="modal-header">
        <span>予約情報検索</span>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="row">
          検索条件: {{ searchStr }}
        </div>
        <div class="row" v-if="isLoading">
          検索中...
        </div>
        <div class="row" v-else>
          <template v-if="reservations.length">
            <ul>
              <li v-for="obj in reservations">
                <a v-link="reservationsLink(obj)" @click="isShown=false">
                  {{ startAtStr(obj) }}〜 {{ obj.customer.familyNameKana }} {{ obj.customer.firstNameKana }}様 {{ obj.customer.account }}
                </a>
              </li>
            </ul>
          </template>
          <template v-else>
            <span>該当する検索結果がありません</span>
          </template>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'reservation-search',
  props: {
    shop: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      reservations: [],
      isShown: false,
      isLoading: true,
      searchStr: null,
    }
  },
  methods: {
    search (val) {
      reservations: []
      this.isShown = true
      this.searchStr = val
      this.isLoading = true
      console.log(val)
      let params = {
        name_or_account: val,
        shop: this.shop.pk,
      }
      this.apiGet(
        '/api/1.0/reservations/',
        params
      ).then(response => {
        console.log(response)
        this.reservations = response.body.results
        this.isLoading = false
        return response
      }).finally(() => {
        this.isLoading = false
      })
    },
    startAtStr (obj) {
      let tmp = moment(obj.startAt)
      return tmp.locale('ja').format('YYYY/MM/DD (ddd) HH:mm〜')
    },
    reservationsLink (obj) {
      let date = moment(obj.startAt)
      return {
        name: 'reservations',
        params: {
          shopId: this.shop.pk,
          year: date.format('YYYY'),
          month: date.format('MM'),
          day: date.format('DD'),
        },
      }
    },
  },
  components: {
    modal: require('ui/modal.vue'),
  },
  mixins: [
    require('mixin/api-client.vue'),
  ],
}
</script>



// WEBPACK FOOTER //
// search.vue?56d46296